export const getDefaultDomainByEnvironment = (environment: string) => {
  const defaultDomainByEnvironment = {
    local: 'bank1_br',
    qa: 'bank1_br',
    demo: 'demo_nab',
  }

  return defaultDomainByEnvironment[environment] || 'demonstration'
}

export const currencies = ['AUD', 'BRL', 'CAD', 'CHF', 'CNH', 'EUR', 'GBP', 'HKD', 'SGD', 'JPY', 'NZD', 'USD'].sort()

export type InterestPaid = 'M' | 'Q' | 'S' | 'A' | 'Z'

export const getInterestPaidCodes = () => ({
  M: 'Monthly',
  Q: 'Quarterly',
  S: 'Semi-Annual',
  A: 'Annual',
  Z: 'At Maturity',
})

export type InstrumentCode = 'CP' | 'ECD' | 'TD' | 'FRN' | 'BOND' | 'CASH' | 'FRTD' | 'MGFUND'

export const getInstrumentCodes = (): InstrumentCode[] => ['CP', 'ECD', 'TD', 'FRN', 'BOND', 'CASH', 'FRTD', 'MGFUND']

export const isBondFrnOrFrtd = (instrumentCode: InstrumentCode): boolean =>
  ['BOND', 'FRN', 'FRTD'].includes(instrumentCode)

export const isDiscountedSecurity = (instrumentCode: InstrumentCode): boolean =>
  ['CP', 'CD', 'ECD'].includes(instrumentCode)

export type MaturityAction = 'reinvested' | 'redeemed'

export type ShortRatings = 'A-1+' | 'A-1' | 'A-2' | 'A-3' | 'B' | 'C' | 'D' | 'Z' | 'Unrated'

export const getShortRatings = (): ShortRatings[] => ['A-1+', 'A-1', 'A-2', 'A-3', 'B', 'C', 'D', 'Z', 'Unrated']

export type LongRatings =
  | 'AAA'
  | 'AA+'
  | 'AA'
  | 'AA-'
  | 'A+'
  | 'A'
  | 'A-'
  | 'BBB+'
  | 'BBB'
  | 'BBB-'
  | 'BB+'
  | 'BB'
  | 'BB-'
  | 'B+'
  | 'B'
  | 'B-'
  | 'CCC+'
  | 'CCC'
  | 'CCC-'
  | 'CC'
  | 'C'
  | 'RD'
  | 'SD'
  | 'D'
  | 'Z'
  | 'Unrated'

export const getLongRatings = (): LongRatings[] => [
  'AAA',
  'AA+',
  'AA',
  'AA-',
  'A+',
  'A',
  'A-',
  'BBB+',
  'BBB',
  'BBB-',
  'BB+',
  'BB',
  'BB-',
  'B+',
  'B',
  'B-',
  'CCC+',
  'CCC',
  'CCC-',
  'CC',
  'C',
  'RD',
  'SD',
  'D',
  'Z',
  'Unrated',
]
